/** Keyless Google Maps embed -- the same "output=embed" form LocationCard
 *  uses on the public page, so the preview matches what visitors see. Used
 *  by Manage -> Hobby Shops and Manage -> Tracks for the saved address. */
export function MapPreview({ address, name }: { address: string; name: string }) {
  return (
    <iframe
      className="location-map-embed"
      src={`https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`}
      loading="lazy"
      title={`Map of ${name}`}
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
}
